// How the reader's middlegame went against how it started
// (`GameFacts.middlegameStart`, `middlegameEnd`, `middlegameResult`): the
// standing at the middlegame's first position, the standing it ended at — the
// last middlegame position when the game went on to an ending, the game's
// outcome when it finished in the middlegame — and the result from the two.
// The rule is api-ending-case's stage grid (`middlegameResultOf`), the one
// the ending results use. A game with no middlegame, or no score at its
// start, has no middlegame result.
import type { GameFacts } from '@chess/api-model';
import { middlegameResultOf, standingOf, standingOfOutcome } from '@chess/api-ending-case';
import type { FactExtractor, ScannedGame } from '../extractor.ts';

export const middlegameResult: FactExtractor = {
  id: 'middlegame-result',
  extract(game: ScannedGame, facts: GameFacts): void {
    const { fromPly, toPly } = game.range('middlegame');
    if (toPly <= fromPly) return;
    const start = standingOf(game.pawnsAt(fromPly), game.rules.winningPawns);
    if (!start) return;
    const ending = game.range('ending');
    const wentOn = ending.toPly > ending.fromPly;
    const end = wentOn ? standingOf(game.pawnsAt(toPly), game.rules.winningPawns) : standingOfOutcome(facts.outcome);
    if (!end) return;
    facts.middlegameStart = start;
    facts.middlegameEnd = end;
    facts.middlegameResult = middlegameResultOf(start, end);
  },
};
